import calendar from "assets/icones/calendar3.svg";
import plant from "assets/icones/plant3.svg";
import student from "assets/icones/student3.svg";
import trash from "assets/icones/trash3.svg";
import volunteer from "assets/icones/volunteer3.svg";

const Data = [
  {
    id: 1,
    title: "Partcipants et volontaires",
    icon: volunteer,
    number: 2000,
  },
  {
    id: 2,
    title: "L de déchets ramassés",
    icon: trash,
    number: 500000,
  },
  {
    id: 3,
    title: "Evenements organisés",
    icon: calendar,
    number: 100,
  },
  {
    id: 4,
    title: "Arbres plantés",
    icon: plant,
    number: 1000,
  },
  {
    id: 5,
    title: "Enfants sensibilisés",
    icon: student,
    number: 200,
  },
];

export default Data;
